// extracted by mini-css-extract-plugin
export default {"pageContainer":"BaseProfilePage_pageContainer__WKb67","fadeIn":"BaseProfilePage_fadeIn__T4J1x","contentContainer":"BaseProfilePage_contentContainer__lMJmK"};